module.exports = __webpack_public_path__ + "static/media/video-letgo-ja.fa3d4d8d.vtt";